import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { EmailTemplateFormComponent } from './email-template-form.component';
import { QuillModule } from 'ngx-quill';

const routes: Routes = [
  { path: '', component: EmailTemplateFormComponent, data: { title: 'Email Template details' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, QuillModule],
})
export class EmailTemplateFormRoutingModule {}

@NgModule({
  imports: [
    EmailTemplateFormRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [EmailTemplateFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmailTemplateFormModule {}
